import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { EnumRequestedAdjustmentsInstitucionalModalType, EnumButtonSizes } from '@/enums/enums'
import { usePagesUtilStore } from '@/stores/pagesUtilStore'
import { useAuthStore } from '@/stores/authStore'
import { useInstitutionalStore } from '@/stores/institutionalStore'
import { CONST_INSTITUTIONAL_STATUS } from '@/static/constantsInstitutional'


export default /*@__PURE__*/_defineComponent({
  __name: 'BtnRequestAdjustmentsToFocusedInstitutional',
  setup(__props) {

const pagesUtilStore = usePagesUtilStore()
const authStore = useAuthStore()
const institutionalStore = useInstitutionalStore()

const onRequestAdjustmentsBtnClick = () => {
  pagesUtilStore.modalRequestedAdjustmentsInstitucionalModalType =
    EnumRequestedAdjustmentsInstitucionalModalType.CREATE
  pagesUtilStore.showModalRequestAdjustmentsInstitucional = true
}

return (_ctx: any,_cache: any) => {
  const _component_c_q_btn = _resolveComponent("c-q-btn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(authStore).currentUserCanReviewInstitutional
      && _unref(institutionalStore).institutionalDetail?.status == _unref(CONST_INSTITUTIONAL_STATUS).ON_APPROVAL.id)
      ? (_openBlock(), _createBlock(_component_c_q_btn, {
          key: 0,
          id: "btn-request-adjustments",
          propBtnLabel: "Solicitar Ajuste",
          propBtnFunction: onRequestAdjustmentsBtnClick,
          propBtnTransparent: true,
          propBtnSize: _unref(EnumButtonSizes).LARGE_1
        }, null, 8, ["propBtnSize"]))
      : _createCommentVNode("", true),
    (_unref(authStore).currentUserCanReviewInstitutional
      && _unref(institutionalStore).institutionalDetail?.status == _unref(CONST_INSTITUTIONAL_STATUS).ON_RE_APPROVAL.id)
      ? (_openBlock(), _createBlock(_component_c_q_btn, {
          key: 1,
          id: "btn-request-adjustments",
          propBtnLabel: "Solicitar Reajuste",
          propBtnFunction: onRequestAdjustmentsBtnClick,
          propBtnTransparent: true,
          propBtnSize: _unref(EnumButtonSizes).LARGE_1
        }, null, 8, ["propBtnSize"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})